import DashboardNavigationBar from '@/components/dashboard/navigation-bar/dashboard-navigation-bar';
import Loading from '@/components/loading/loading';
import { Box } from '@cmpsr/components';
import TestingPlanHeader from './components/testing-plan-header/testing-plan-header';
import TestingPlanTabs from './components/testing-plan-tabs/testing-plan-tabs';
import useTestingPlan from './testing-plan.controller';

export default function TestingPlanPage() {
  const { isLoading } = useTestingPlan();

  if (isLoading) {
    return <Loading />;
  }

  return (
    <>
      <DashboardNavigationBar activeItem="testing-plan" />
      <Box width="100%" height="100%" textAlign="center" flexGrow="1">
        <TestingPlanHeader />
        <TestingPlanTabs />
      </Box>
    </>
  );
}
